export default "__VITE_ASSET__5ebbdedc__"